(() => {
  const storageKey = '3dswear-wishlist-v1';

  const readItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items.filter((item) => item && typeof item.handle === 'string') : [];
    } catch (_error) {
      return [];
    }
  };

  const writeItems = (items) => {
    localStorage.setItem(storageKey, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('gift:wishlist-change', { detail: { items } }));
  };

  const syncButtons = (items = readItems()) => {
    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = handles.has(button.dataset.wishlistHandle);
      const title = button.dataset.wishlistTitle || 'this product';
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} ${title} ${saved ? 'from' : 'to'} wishlist`);
    });
  };

  const renderPage = (items = readItems()) => {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid || !empty) return;

    grid.replaceChildren();
    grid.hidden = items.length === 0;
    empty.hidden = items.length > 0;

    items.forEach((item) => {
      const card = document.createElement('article');
      card.className = 'gift-wishlist-card';

      const link = document.createElement('a');
      link.className = 'gift-wishlist-card__link';
      link.href = typeof item.url === 'string' && item.url.startsWith('/products/') ? item.url : '/collections/all';

      if (typeof item.image === 'string' && /^(https:)?\/\//.test(item.image)) {
        const image = document.createElement('img');
        image.src = item.image.startsWith('//') ? `https:${item.image}` : item.image;
        image.alt = item.title || 'Wishlist product';
        image.loading = 'lazy';
        link.append(image);
      }

      const title = document.createElement('h2');
      title.textContent = item.title || 'Saved product';
      link.append(title);

      const price = document.createElement('p');
      price.textContent = item.price || '';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'gift-wishlist-card__remove';
      remove.dataset.wishlistRemove = item.handle;
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', `Remove ${item.title || 'product'} from wishlist`);

      card.append(link, price, remove);
      grid.append(card);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const handle = toggle.dataset.wishlistHandle;
      if (!handle) return;

      const items = readItems();
      const index = items.findIndex((item) => item.handle === handle);
      const adding = index < 0;
      if (adding) {
        items.push({
          handle,
          title: toggle.dataset.wishlistTitle || '',
          url: toggle.dataset.wishlistUrl || '',
          image: toggle.dataset.wishlistImage || '',
          price: toggle.dataset.wishlistPrice || '',
        });
      } else {
        items.splice(index, 1);
      }

      writeItems(items);
      syncButtons(items);
      renderPage(items);
      const status = document.querySelector('[data-wishlist-status]');
      if (status) status.textContent = adding ? 'Added to wishlist' : 'Removed from wishlist';
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (!remove) return;
    const items = readItems().filter((item) => item.handle !== remove.dataset.wishlistRemove);
    writeItems(items);
    syncButtons(items);
    renderPage(items);
  });

  document.addEventListener('gift:wishlist-change', (event) => {
    syncButtons(event.detail.items);
    renderPage(event.detail.items);
  });

  syncButtons();
  renderPage();
})();
